class ScrollUtilities {
    public jumpToDivCenter(divId: string, instant: boolean = false, highlightAnimation: boolean = false): void {
        const div: HTMLDivElement = document.getElementById(divId) as HTMLDivElement;

        if (!div) {
            console.error(`Could not find div for id ${divId}.`);
            return;
        }

        div.scrollIntoView({ block: "center", behavior: instant ? "instant" : "smooth" });

        if (highlightAnimation) {
            this.addHighlightBounceToDiv(div);
        }
    }

    public jumpToTop() {
        window.scrollTo(0, 0);
        return;
    }

    public addHighlightBounceToDiv(div: HTMLDivElement): void {
        div.removeEventListener("animationend", () => div.classList.remove("highlight-bounce"));
        div.classList.remove("highlight-bounce");

        void div.offsetWidth; // this is done to restart the animation

        div.classList.add("highlight-bounce");
        div.addEventListener("animationend", () => div.classList.remove("highlight-bounce"), { once: true });
    }
}

export default new ScrollUtilities();
